export const DATE = {
    FORMAT: "YYYY-MM-DD",
    TABLE_FORMAT: "DD/MM/YYYY",
    INPUT_FORMAT: "MM/DD/YYYY",
    HEADER_FORMAT: "DD/MM",
    FULL_FORMAT: "DD/MM/YYYY HH:mm",
    MIN: "2000-01-01",
    MAX: "3000-12-31",
} as const;

export const MAX_LOCALSTORAGE_ITEMS = 10 as const;
